import * as firstStart from 'modules/first-start';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { routingService } from 'services/routing';

const useNewOrganisationData = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(firstStart.loadNewOrganisationSetup({}));

        routingService.replaceToDefaultPath();
    }, [dispatch]);
};

export default useNewOrganisationData;
